// ANCHOR GraphQL
import { Form_Question_Types_Enum as QuestionType } from '@lyon/graphql/types';

export const RADIO_NAME = 'Select a Question Type';

export const RADIOS = [
  {
    value: QuestionType.ShortAnswer,
    label: 'Short Answer',
    description: 'The expected answer is a short text. You can choose whether it should be case strict or case insensitive.',
  },
  {
    value: QuestionType.Essay,
    label: 'Essay/Long Answer',
    description: 'The expected answer is a long text and open-ended. You have the option to check it for grading after submission.',
  },
  {
    value: QuestionType.MultipleChoice,
    label: 'Multiple Choice',
    description: 'The student will pick one answer from a set of given choices. You can set more than one choice as an answer.',
  },
  {
    value: QuestionType.CheckboxAnswer,
    label: 'Checkbox Question',
    description: 'The student is allowed to select multiple answers from a set of given choices.',
  },
  {
    value: QuestionType.Attachment,
    label: 'Attachment Upload',
    description: 'The student will upload an attachment as their answer.',
  },
  {
    value: QuestionType.Spacer,
    label: 'Spacer',
    description: 'This can be used for title cards, welcome message, or for a thank you message at the end.',
  },
];
